import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {  } from '@angular/animations';

import { steppedFlyX, flyIn, overlay, expandablepoint } from '../store/item/item.animations';
import { animateOpen, rotateOpen,  flyInOut, fadeIn, fade, featureslist, zFade, Cart, ShareMenu, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, featuresBox } from '../store/animations';

import { environment } from '../environment';
import { Module } from '../models/module';

@Component({
  selector: 'app-prison-life',
  templateUrl: './info.prison-life.component.html',
  animations: [ expandablepoint, steppedFlyX, overlay, flyIn, flyInOut, fadeIn, animateOpen, rotateOpen, featuresBox, featureslist, fade, zFade, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, ShareMenu ]
})
export class PrisonLifeComponent implements OnInit {

	title: string;
	header: any;
  headerHeight: any;
	headerAlign: any;
	subtitle: string;
  showImage = 0;
  showModel = 0;
  itemImages = 0;
  LightboxImage = "";
  LightboxTitle = "";
  ShowLightbox: any;

  constructor(private http      : Http,
              private sanitizer : DomSanitizer ) { }

  ngOnInit() {
  	this.title = 'PRISON LIFE';
    this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/art/prison-concept.png") no-repeat center center' );
  	this.subtitle = '';
    this.headerHeight = '545px';
    this.headerAlign = 'left';
  }

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/info/info.prison-life.component.ts